if(!customElements.get("cart-recommendations")){class a extends HTMLElement{constructor(){super(),this.wrapper=this.querySelector(".swiper-wrapper"),this.getRecommendations()}getRecommendations(intent) {
        if (!this.dataset.products) return;

        const source = intent || "complementary";
        const ids = this.dataset.products.split(",");
        const root = window.Shopify.routes.root;

        Promise.all(ids.map((id) => fetch(
            `${root}recommendations/products?product_id=${id}&limit=10&section_id=product-recommendations-content&intent=${source}`
        ).then((response) => response.text()))).then((responses) => {
            responses.forEach((html) => {
                const fragment = new DOMParser().parseFromString(html, "text/html");

                if (!fragment.querySelector("product-card")) return;

                const previous = this.wrapper.innerHTML;

                this.wrapper.innerHTML = fragment.querySelector(".swiper-wrapper").innerHTML;
                this.wrapper.innerHTML += previous;
            });

            // Produkty juz lezace w koszyku oraz powtorki wypadaja z karuzeli.
            const seen = ids.slice();

            this.wrapper.querySelectorAll("product-card").forEach((card) => {
                if (seen.indexOf(card.dataset.productId) !== -1) {
                    card.closest(".swiper-slide").remove();
                    return;
                }

                seen.push(card.dataset.productId);
            });

            if (this.wrapper.querySelector("product-card")) {
                this.initCarousel();
                return;
            }

            // Sklep nie ma ustawionych produktow komplementarnych dla tych pozycji -
            // wtedy pokazujemy polecane, zeby sekcja z projektu nie znikala z koszyka.
            if (source === "complementary") {
                this.getRecommendations("related");
                return;
            }

            this.remove();
        });
    }

    initCarousel(){this.mountQuickAdd();var e=this.querySelector(".swiper-scrollbar"),t=this.querySelector(".arrow--left"),r=this.querySelector(".arrow--right");new Swiper(this.querySelector(".swiper-container"),{mousewheel:{enabled:!0,forceToAxis:!0,releaseOnEdges:!0,thresholdDelta:8},loop:!1,grabCursor:!1,speed:500,spaceBetween:8,slidesPerView:this.dataset.slidesPerView,watchSlidesProgress:!0,scrollbar:{el:e,enabled:!0},navigation:{nextEl:r,prevEl:t},breakpoints:{768:{spaceBetween:8,slidesPerView:this.dataset.slidesPerView},1400:{spaceBetween:16,slidesPerView:this.dataset.slidesPerView}}});this.style.display="block",setTimeout(()=>{window.dispatchEvent(new Event("resize")),this.style.opacity=1},100)}

    // Szybkie dodanie polecanego produktu do koszyka (projekt: czarne kolko 48 px
    // w prawym dolnym rogu zdjecia). Karty przychodza z API sekcji rekomendacji,
    // dlatego przycisk doklejamy po ich wstawieniu, klonujac wzor z szablonu.
    mountQuickAdd() {
        const template = this.querySelector("[data-quick-add-template]");

        if (!template) return;

        this.querySelectorAll("product-card").forEach((card) => {
            const media = card.querySelector(".product-card__media");
            const variant = card.dataset.variantId;

            if (!media || !variant || card.querySelector("[data-quick-add]")) return;

            const layer = document.createElement("div");

            layer.className = "product-card__quick-add-layer";
            layer.appendChild(template.content.cloneNode(true));
            layer.querySelector("[data-quick-add]").dataset.variantId = variant;
            media.insertAdjacentElement("afterend", layer);
        });

        if (this.quickAddBound) return;

        this.quickAddBound = true;
        this.addEventListener("click", (event) => {
            const button = event.target.closest("[data-quick-add]");

            if (!button) return;

            event.preventDefault();
            this.quickAdd(button);
        });
    }

    quickAdd(button) {
        if (button.classList.contains("loading")) return;

        button.classList.add("loading");

        const properties = JSON.parse(button.closest("product-card")?.dataset.shippingProperties || "{}");

        fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1, properties }] })
        })
            .then((response) => response.json())
            .then((data) => {
                if (!data.items) return;

                window.dispatchEvent(new CustomEvent("cartAdded", { detail: { added: true } }));
                window.dispatchEvent(new CustomEvent("cartCounterUpdate"));
            })
            .catch((error) => console.error(error))
            .finally(() => button.classList.remove("loading"));
    }
}customElements.define("cart-recommendations",a)}
